<template>
  <div class="main">
   <div v-if="which_pop == 'date'" class="pop_dialog">
        <div class="pop_header"><h2>{{ $t('cityRanking_selection.timeframe')}}</h2></div>
        <div class="pop_body">
            <ul class="list" >
                <li v-for="(item, index) in dates_" :key="index" :class="{active: date_.value == item.value}"
                @click="select_option(item, 'date')">{{ item.label }}</li>
            </ul>
        </div>
        <div class="pop_footer">
            <el-button plain type="button" @click="cancel">{{ $t('cityRanking_selection.cancel')}}</el-button>
        </div>
   </div>

   <div v-if="which_pop == 'comparison'" class="pop_dialog">
        <div class="pop_header"><h2>{{ $t('cityRanking_selection.comparison')}}</h2></div>
        <div class="pop_body">
            <ul class="list">
                <li v-for="(item, index) in comparisons_" :key="index" :class="{active: comparison_.value == item.value}"
                @click="select_option(item, 'comparison')">{{ item.label }}</li>
            </ul>
        </div>
        <div class="pop_footer">
            <el-button plain type="button" @click="cancel">{{ $t('cityRanking_selection.cancel')}}</el-button>
        </div>
    </div>

    <div v-if="which_pop == 'country'" class="pop_dialog_country">
        <div class="pop_header">
            <h2>{{ $t('cityRanking_selection.selectRegion')}}</h2>
            <span class="close-btn" @click="cancel"></span>
            <el-radio-group v-model="tabSelected">
                <el-radio-button label="continets">{{ $t('cityRanking_selection.continets')}}</el-radio-button>
                <el-radio-button label="countries">{{ $t('cityRanking_selection.countries')}}</el-radio-button>
            </el-radio-group>
        </div>
        <div class="pop_body" :class="{'tab-country': tabSelected == 'countries'}">
            <div v-if="tabSelected == 'continets' ">
                <el-button v-for="(item, index) in countries_" :key="index" type="primary" round class="country-btn" 
                @click="select_option(item, 'country')">{{item.label}}</el-button>
            </div>
            <div v-else>
                <ul v-for="(continent, index) in countries_" :key="index" :class="{active: country_.value == continent.value}">
                    <li v-for="(country, index) in continent.children" :key="country.value" v-show="country.label.toLowerCase().indexOf(filter.toLowerCase()) != -1">
                        <div v-if="index == 0" class="item-country">{{ country.label | formatName }}</div>
                        <div v-else class="item-countient" :class="{'active' : country.label == (country_ && country_.label) }" @click="select_option(country, 'country')">{{ country.label | formatName }}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CityRankingSelection",
  props: {
      "field":{},
      "which_pop":""
    },
  data() {
    return {
        date_: this.field.date,
        dates_: this.field.dates,
        comparison_: this.field.comparison,
        comparisons_: this.field.comparisons,
        countries_: this.field.countries,
        country_: this.field.country,
        filter: "",
        tabSelected: "continets",
    };
  },

  beforeMount() {
    //   this.filterCountries = this.field.countries;
  },

  methods: {

    //   filterCountry(){
    //       console.log(this.filter);
    //     // if(this.filter.length = 0) return ;
    //     let filter = this.filter.toLowerCase();
    //     console.log(this.countries_);
    //     this.countries_ = this.countries_.filter( it => {
    //             // it.children.forEach(element => {
    //             //     element.label.toLowerCase().indexOf(filter) == -1
    //             // });
    //             console.log(it);
    //             it.value.indexOf(filter) != -1
    //             // if(it.children.label.toLowerCase().indexOf(filter) == -1){
    //             //     it.children.style.display = 'none';
    //             // }else if(it.value.indexOf(filter) == -1){
    //             //     it.style.display = 'none';
    //             // }
    //         })
    //     console.log(this.countries_);
    //   },

      select_option(val, flag){
        if(flag == 'date'){
            this.date_ = val;
        }else if(flag == 'comparison'){
            this.comparison_ = val;
        }else if(flag == "country"){
            this.country_ = val;
        }
        this.submit(flag);
      },

      submit(flag){
          this.$emit('pop_callback', {
              date: this.date_,
              comparison: this.comparison_,
              country: this.country_,
              flag: flag
              });
      },

      cancel(){
          this.$emit('pop_callback', { isCancelAction : true });
      },

  },

    filters: {
        formatName: function (val){
            let newVal = val.split("All ");
            if(newVal.length > 1 ){
                newVal = newVal[1]
            }else {
                newVal = newVal[0]
            }
            return newVal;
        },
    },
};
</script>

<style scoped>
.main {
    overflow: auto;
    font-family: -apple-system, BlinkMacSystemFont;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: rgba(0,0,0, .5);
}


.pop_dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 270px;
    background-color: var(--white);
    border-radius: 6px;
}

.pop_dialog_country {
    width: calc(100% - 32px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--white);
    border-radius: 6px;
}

.pop_dialog_country .pop_header {
    padding: 20px 18px;
    position: relative;
}

.pop_dialog_country .pop_header .el-radio-group {
    width: 100%;
}

.pop_dialog_country .pop_header >>> .el-radio-group .el-radio-button {
    width: 50%;
}

.pop_dialog_country .pop_header >>> .el-radio-group .el-radio-button  .el-radio-button__inner {
    font-weight: normal;
    width: 100%;
    height: 27px;
    padding: 0;
    border-color: var(--windows-blue);
    color: var(--windows-blue);
    line-height: 27px;
}

.pop_dialog_country .pop_header >>> .el-radio-group .el-radio-button.is-active  .el-radio-button__inner, .pop_dialog_country .pop_header >>> .el-radio-group .el-radio-button.is-focus  .el-radio-button__inner {
    border: none;
    outline: none;
    color: #fff;
    box-shadow: none;
    background-color: var(--windows-blue);
}

.pop_dialog_country .pop_header h2{
    margin-bottom: 10px;
}

.pop_dialog_country .pop_header .close-btn  {
    content: '';
    display: block;
    position: absolute;
    right: 15px;
    top: 15px;
    width: 24px;
    height: 24px;
    background: url("../../../website_20/static/img/icon-close.svg") no-repeat;

}
.pop_dialog_country .pop_body {
    border-top: 1px solid #d8d8d8;
    padding: 5px 18px 0;
    height: 440px;
    overflow: auto;
}

.pop_dialog_country .pop_body >>> .country-btn {
    height: 40px;
    line-height: 40px;
    background-color: rgb(242, 247, 255);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-weight: normal;
    font-size: 16px;
    text-align: center;
    color: rgb(51, 51, 51);
    padding: 0 20px;
    margin: 0 6px 15px 0;
    border: none;
}

.pop_dialog_country .pop_body.tab-country {
    background-color: rgb(246, 249, 252);
}

.pop_dialog_country .pop_body.tab-country .item-country {
    font-size: 15px;
    font-weight: 500;
    letter-spacing: -0.4px;
    color: rgb(51, 51, 51);
    margin-top: 15px;
}

.pop_dialog_country .pop_body.tab-country .item-countient {
    margin-left: 13px;
    height: 44px;
    line-height: 44px;
    font-size: 15px;
    color: rgb(74, 74, 74);
    border-bottom: 1px solid #d8d8d8;
}
.pop_dialog_country .pop_body.tab-country .item-countient.active {
    color: var(--windows-blue);
    position: relative;
    font-weight: bold;
}

.pop_dialog_country .pop_body.tab-country .item-countient.active:after {
    content: '';
    position: absolute;
    width: 15px;
    height: 13px;
    right: 2px;
    top: 16px;
    background: url('../../../website_20/static/img/icon-indicator.svg') no-repeat;
}

.pop_dialog .pop_header {
    padding: 20px 15px;
    border-bottom: 1px solid rgb(216, 216, 216);
}

.pop_dialog .pop_header h2, .pop_dialog_country .pop_header h2{
    font-size: 13px;
    text-align: center;
    color: var(--brownish-grey);
}

.pop_dialog .pop_body {
    padding-left: 20px;
    background-color: rgb(246, 249, 252);
}
.pop_dialog .pop_body .list {
    height: auto;
    max-height: 200px;
    overflow: scroll;
}

.pop_dialog .pop_body .list li {
    font-size: 15px;
    text-align: left;
    margin-right: 20px;
    color: rgb(51, 51, 51);
    padding: 14px 0 11px;
}

.pop_dialog .pop_body .list li:not(:last-child){
    border-bottom: 1px solid rgb(216, 216, 216);
}

.pop_dialog .pop_body .list li.active {
    font-weight: bold;
    color: var(--windows-blue);
}

.pop_dialog .pop_footer button{
    font-size: 13px;
    text-align: center;
    color: rgb(3, 3, 3);
    width: 100%;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}

.pop_select {
    background-color: #fff;
}

.pop_select .search {
    padding: 12px 16px;
}

.pop_select .search input {
    box-shadow: none;
    border: 0;
    -webkit-appearance: none;
    height: 36px;
    border-radius: 6px;
    font-size: 17px;
    padding-left: 30px;
    width: 100%;
    color: #333;
    background-color: rgba(142, 142, 147, 0.24);
}

.pop_select .search input::placeholder {
    color: rgb(142, 142, 147);
}

.pop_select .pop_list .all_countries {
    height: 36px;
    line-height: 36px;
    padding-left: 16px;
    background-color: rgb(242, 247, 255);
    font-size: 17px;
    font-weight: 500;
    color: rgb(74, 74, 74)
}

.pop_select .pop_list .continent {
    height: 36px;
    line-height: 36px;
    padding-left: 16px;
    background-color: rgb(247, 247, 247);
}

.pop_select .pop_list li {
    padding-left: 30px;
    height: 44px;
    line-height: 44px;
    font-size: 15px;
    color: rgb(74, 74, 74);
    cursor: pointer;
}

.pop_select .pop_list li.active {
    font-weight: bold;
    color: var(--windows-blue);
}

</style>


// WEBPACK FOOTER //
// src/components/CityRanking_selection.vue